import { render } from "./IndexCashMovements.vue?vue&type=template&id=05c7630a"
import script from "./IndexCashMovements.vue?vue&type=script&lang=js"
export * from "./IndexCashMovements.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__